/*
 * Copyright (c) 2025.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/*
* studierichting.ts
* 10-10-2024 - Jelmer Jellema - Spin in het Web B.V.
*
* Datamodel voor studierichting
*/

import {Basemodel, ModelField, ModelRelation} from "./basemodel";
import {Profielkeuze} from "./profielkeuze";

export class Studierichting extends Basemodel {
  @ModelField() override id: number;
  @ModelField() niveau: 'wo'|'hbo' | 'mbo' = 'wo';
  @ModelField() sector: string;
  @ModelField() studierichting: string;
  opleidingsniveau: string = ''; //kan er zijn, hoeft niet, combineren we in studierichting
  @ModelField() d_D: boolean = false;
  @ModelField() d_DI: boolean = false;
  @ModelField() d_DS: boolean = false;
  @ModelField() d_DC: boolean = false;
  @ModelField() d_DIS: boolean = false;
  @ModelField() d_DIC: boolean = false;
  @ModelField() d_DSC: boolean = false;
  @ModelField() d_I: boolean = false;
  @ModelField() d_ID: boolean = false;
  @ModelField() d_IS: boolean = false;
  @ModelField() d_IC: boolean = false;
  @ModelField() d_IDS: boolean = false;
  @ModelField() d_IDC: boolean = false;
  @ModelField() d_ISC: boolean = false;
  @ModelField() d_S: boolean = false;
  @ModelField() d_SD: boolean = false;
  @ModelField() d_SI: boolean = false;
  @ModelField() d_SC: boolean = false;
  @ModelField() d_SDI: boolean = false;
  @ModelField() d_SDC: boolean = false;
  @ModelField() d_SIC: boolean = false;
  @ModelField() d_C: boolean = false;
  @ModelField() d_CD: boolean = false;
  @ModelField() d_CI: boolean = false;
  @ModelField() d_CS: boolean = false;
  @ModelField() d_CDI: boolean = false;
  @ModelField() d_CDS: boolean = false;
  @ModelField() d_CIS: boolean = false;

  @ModelRelation({model: Profielkeuze}) Profielkeuze: Profielkeuze[];

  /**
   * Helper: vind de juiste profielkeuze
   * @param profielkeuze
   */
  profielkeuzevoor(profielkeuze: string): Profielkeuze | null
  {
    return this.Profielkeuze.find(pk => pk.profielkeuze === profielkeuze) ?? null;
  }
  /**
   * Geeft true als de studie past bij de genoemde profielkeuzestring
   * @param profielkeuze
   */
  voorProfielkeuze(profielkeuze: string): boolean {
    return !! this.profielkeuzevoor(profielkeuze);
  }

  profielkeuzeOpmerking(profielkeuze: string): string {
    console.log(this.Profielkeuze, profielkeuze);
    return this.profielkeuzevoor(profielkeuze)?.opmerking || "";
  }
}
